module.exports = __webpack_public_path__ + "static/img/5.0bdc01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-trans-mercancias-especifico/5.png
// module id = ce8X
// module chunks = 0